// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2hjo9","rootSmall":"AddTileButton_rootSmall__Plf4D"};